import httpClient from "./httpClient";

const prefix = "/admin-notifications";

export type AdminNotification = {
  id: number;
  title: string;
  body: string;
  isRead: boolean;
  createdAt: string;
  module?: string | null;
  action?: string | null;
  link?: string | null;
  meta?: Record<string, unknown> | null;
};

export type AdminNotificationsPage = {
  items: AdminNotification[];
  total: number;
  unreadCount: number;
};

export async function fetchMyAdminNotifications(
  limit = 20,
  offset = 0
): Promise<AdminNotificationsPage> {
  return (
    await httpClient.get(`${prefix}/me`, {
      params: { limit, offset },
    })
  ).data;
}

export async function fetchAdminUnreadCount(): Promise<{ count: number }> {
  return (await httpClient.get(`${prefix}/me/unread-count`)).data;
}

export async function markAdminNotificationRead(
  id: number
): Promise<AdminNotification> {
  return (await httpClient.patch(`${prefix}/${id}/read`)).data;
}

export async function markAllAdminNotificationsRead(): Promise<{
  updated: number;
  count: number;
}> {
  return (await httpClient.patch(`${prefix}/read-all`)).data;
}

export async function seedAdminNotificationsDemo() {
  return (await httpClient.post(`${prefix}/seed-demo`)).data;
}
